module.exports = __webpack_public_path__ + "static/WEDDING E&M-399-2c3397b11be1d08c02fb64fbde402b3b.jpg";